<div class="legal">
  <h1>Termos de Uso</h1>
  <p class="updated">Última atualização: {{ info.updatedAt }}</p>

  <p>
    Estes termos regem o uso do <strong>NCommerce</strong>: o site ncommerce.app, o cadastro, o sistema instalado nos
    estabelecimentos e as páginas públicas que os estabelecimentos oferecem aos seus clientes. Ao criar uma conta,
    instalar o sistema ou usar essas páginas, você concorda com estes termos e com a
    <a routerLink="/privacidade">Política de Privacidade</a>. Se não concordar, não use o NCommerce.
  </p>
  <p>
    Para os estabelecimentos, a contratação também é regida pelo <strong>Contrato de Prestação de Serviços</strong>
    aceito no cadastro. Se houver conflito, prevalece o contrato.
  </p>

  <h2>1. Quem oferece o NCommerce</h2>
  <p>
    {{ info.company }}, CNPJ {{ info.cnpj }}, com sede em {{ info.address }} ("NCommerce", "nós").
  </p>

  <h2>2. O que é o NCommerce</h2>
  <p>
    Um sistema de gestão para estabelecimentos de alimentação que inclui, conforme o plano: frente de caixa, comandas e
    mesas, controle de pedidos, delivery, emissão de NFC-e, impressão de pedidos, cardápio digital, site de pedidos
    online, reservas, avaliações de clientes, autoatendimento e integrações com plataformas parceiras. O sistema é
    instalado no computador do estabelecimento e se comunica com os nossos servidores.
  </p>

  <h2>3. Cadastro e conta</h2>
  <ul>
    <li>O cadastro é exclusivo para empresas com CNPJ ativo (incluindo MEI), representadas por pessoa maior de 18
      anos com poderes para contratar.</li>
    <li>Você deve informar dados verdadeiros e mantê-los atualizados. Podemos recusar ou cancelar cadastros com dados
      falsos ou incompletos.</li>
    <li>A conta é pessoal. Você é responsável por guardar sua senha e por tudo o que for feito com ela. Avise-nos
      imediatamente se suspeitar de uso indevido.</li>
    <li>A conta criada no site não é o usuário administrador do sistema instalado. Após a instalação, troque a senha
      padrão do administrador.</li>
  </ul>

  <h2>4. Planos, limites e pagamento</h2>
  <h3>4.1. Plano Grátis</h3>
  <ul>
    <li>Até 500 pedidos de produtos criados por mês, 100 visitas ao cardápio digital por mês e 50 visitas ao site de
      reservas por mês (cada visitante conta uma vez por dia);</li>
    <li>Não inclui site de pedidos online, site de avaliações, confirmações automáticas de pedidos e reservas por
      WhatsApp nem autoatendimento;</li>
    <li>Suporte por atendimento automatizado e por e-mail;</li>
    <li>As demais funcionalidades do sistema ficam disponíveis.</li>
  </ul>
  <h3>4.2. Plano Essencial</h3>
  <ul>
    <li>{{ info.essentialPlanPrice }} por mês, por estabelecimento;</li>
    <li>Todas as funcionalidades sem limite de uso, exceto as confirmações automáticas de pedidos e reservas por
      WhatsApp e o autoatendimento (por QR Code na mesa ou por tablet);</li>
    <li>Suporte prioritário.</li>
  </ul>
  <h3>4.3. Plano Completo</h3>
  <ul>
    <li>{{ info.completePlanPrice }} por mês, por estabelecimento;</li>
    <li>Todas as funcionalidades sem limite de uso, incluindo as confirmações automáticas de pedidos e reservas por
      WhatsApp e o autoatendimento (por QR Code na mesa ou por tablet);</li>
    <li>Suporte prioritário.</li>
  </ul>
  <h3>4.4. Limites</h3>
  <p>
    Ao atingir 80% de um limite do Plano Grátis, avisamos por e-mail e WhatsApp. Ao atingir 100%, o recurso
    correspondente (criação de pedidos, cardápio digital ou site de reservas) fica bloqueado até o início do mês
    seguinte ou até a contratação de um plano pago. O desbloqueio é automático após a confirmação do pagamento.
  </p>
  <h3>4.5. Pagamento</h3>
  <ul>
    <li>As cobranças são emitidas pelo Asaas, nosso parceiro de pagamentos, e pagas por boleto, Pix ou cartão,
      conforme as opções disponíveis.</li>
    <li>O atraso no pagamento leva ao bloqueio do sistema e depois à suspensão dos serviços até o pagamento, nos
      prazos do contrato.</li>
    <li>Podemos reajustar preços ou mudar o que cada plano inclui, avisando com pelo menos 30 dias de antecedência.</li>
  </ul>

  <h2>5. Instalação e requisitos</h2>
  <ul>
    <li>O estabelecimento fornece o computador, a internet e a energia. O computador deve atender aos requisitos
      informados no cadastro (Windows 10, Windows 11 ou Ubuntu 20.04 ou mais recente, com processador e memória
      mínimos). Computadores Apple ainda não são suportados.</li>
    <li>O instalador também configura ferramentas de acesso remoto para que nossa equipe possa instalar, atualizar e dar
      suporte. Não as remova; sem elas, podemos não conseguir atender.</li>
    <li>O sistema recebe atualizações automáticas de correção, segurança e novas funcionalidades.</li>
  </ul>

  <h2>6. Responsabilidades do estabelecimento</h2>
  <ul>
    <li>Cadastrar corretamente produtos, preços, impostos, dados fiscais, certificado digital e demais configurações.
      O NCommerce é uma ferramenta; a correção das informações fiscais e o cumprimento das obrigações tributárias são do
      estabelecimento.</li>
    <li>Cumprir o que oferece aos seus clientes: preços, prazos, entregas, reservas, trocas e devoluções, e atender às
      normas sanitárias e de defesa do consumidor.</li>
    <li>Tratar os dados dos seus clientes e funcionários de acordo com a LGPD. Para esses dados, o estabelecimento é o
      controlador e o NCommerce atua como operador.</li>
    <li>Não usar o NCommerce para enviar mensagens não solicitadas (spam) ou para fins ilegais.</li>
  </ul>

  <h2>7. Para os clientes dos estabelecimentos</h2>
  <p>
    Quando você faz um pedido, uma reserva ou uma avaliação em uma página de um estabelecimento no ncommerce.app, a
    relação de consumo é com o estabelecimento. Ele é o responsável pelos produtos, preços, prazos, entrega, pagamento,
    atendimento e pela confirmação da reserva. O NCommerce fornece a tecnologia e, se você tiver um problema com o
    sistema em si, pode nos procurar.
  </p>

  <h2>8. Uso proibido</h2>
  <p>Não é permitido:</p>
  <ul>
    <li>copiar, revender, sublicenciar, descompilar, fazer engenharia reversa ou modificar o sistema;</li>
    <li>contornar limites de plano, mecanismos de segurança ou de licenciamento;</li>
    <li>usar robôs, fazer pedidos ou reservas falsos ou sobrecarregar os nossos servidores;</li>
    <li>acessar dados de outros estabelecimentos ou de outras pessoas sem autorização;</li>
    <li>usar o NCommerce para qualquer atividade ilegal.</li>
  </ul>

  <h2>9. Disponibilidade e suporte</h2>
  <ul>
    <li>Trabalhamos para manter o NCommerce disponível o tempo todo, mas podem ocorrer interrupções por manutenção,
      falhas de internet, de energia, do computador do estabelecimento ou de serviços de terceiros.</li>
    <li>O sistema instalado continua funcionando no computador do estabelecimento mesmo sem internet; as funções que
      dependem da internet (como pedidos online, cardápio digital, reservas, avaliações e cópias de segurança) voltam
      quando a conexão volta.</li>
    <li>Os canais e prazos de suporte dependem do plano contratado.</li>
  </ul>

  <h2>10. Propriedade intelectual</h2>
  <p>
    O NCommerce, sua marca, código, telas e materiais pertencem a {{ info.company }}. Concedemos ao estabelecimento uma
    licença de uso pessoal, não exclusiva e intransferível, enquanto durar a contratação. Os dados cadastrados pelo
    estabelecimento continuam sendo dele.
  </p>

  <h2>11. Limitação de responsabilidade</h2>
  <p>
    Na medida permitida pela lei, o NCommerce não responde por: decisões de negócio do estabelecimento; informações
    cadastradas incorretamente; falhas de equipamentos, internet ou energia do estabelecimento; perda de dados causada
    por uso indevido, remoção das cópias de segurança ou danos ao computador; nem por atos de serviços de terceiros
    fora do nosso controle. Nada nestes termos limita direitos garantidos pelo Código de Defesa do Consumidor a quem
    for consumidor.
  </p>

  <h2>12. Suspensão e encerramento</h2>
  <ul>
    <li>O estabelecimento pode cancelar a qualquer momento, conforme o contrato.</li>
    <li>Podemos suspender ou encerrar contas que violem estes termos ou o contrato, ou que deixem de pagar, avisando
      antes sempre que possível.</li>
    <li>Ao fim da contratação, o estabelecimento pode pedir uma cópia dos seus dados. Depois disso, excluímos os dados
      dos nossos servidores, exceto o que a lei nos obriga a guardar.</li>
  </ul>

  <h2>13. Mudanças nestes termos</h2>
  <p>
    Podemos atualizar estes termos. A data no topo mostra a última versão. Mudanças relevantes serão avisadas com pelo
    menos 30 dias de antecedência por e-mail ou WhatsApp. Continuar usando o NCommerce depois disso significa concordar
    com a nova versão.
  </p>

  <h2>14. Lei aplicável e foro</h2>
  <p>
    Estes termos seguem as leis do Brasil. Fica eleito o foro da comarca de {{ info.forum }} para resolver qualquer
    questão, exceto quando a lei garantir ao consumidor o foro do seu domicílio.
  </p>

  <h2>15. Contato</h2>
  <p>
    <a [href]="'mailto:' + info.contactEmail">{{ info.contactEmail }}</a>
  </p>
</div>
